import RoundedLetter from './RoundedLetter';

export default RoundedLetter;
